<template>
  <div class="topbar">
    <div class="topbar-left">
      <span class="company-name">企业管理</span>
      <div class="announcement">
        <span class="announcement-label">公告：</span>
        <span class="announcement-text"></span>
      </div>
    </div>
    
    <div class="topbar-right">
      <div class="topbar-nav-item">
        <button @click="toggleDropdown('messages')">
          <i class="fas fa-bell"></i>
        </button>
      </div>
      
      <div class="topbar-nav-item">
        <button @click="toggleDropdown('settings')">
          <i class="fas fa-cog"></i>
        </button>
      </div>
      
      <div class="topbar-divider"></div>
      
      <div class="user-info" @click="toggleDropdown('user')">
        <span class="user-name">{{ currentUser.name ? '您好，' + currentUser.name : '您好！' }}</span>
        <div class="user-avatar">
          <i class="fas fa-user"></i>
        </div>
      </div>
    </div>
    
    <div v-if="dropdowns.user" class="dropdown-menu user-dropdown">
      <button class="dropdown-item" @click="handleLogout">
        <i class="fas fa-sign-out-alt"></i>
        <span>退出登录</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { logout as sessionLogout, getUser } from '../utils/sessionManager'

const router = useRouter()
const currentUser = ref({ name: '' })
const dropdowns = ref({
  messages: false,
  settings: false,
  user: false
})

const toggleDropdown = (type) => {
  Object.keys(dropdowns.value).forEach(key => {
    dropdowns.value[key] = key === type ? !dropdowns.value[key] : false
  })
}

const handleLogout = async () => {
  if (await $confirm('确定要退出登录吗？')) {
    sessionLogout()
  }
}

onMounted(() => {
  const user = getUser()
  if (user) {
    currentUser.value = user
  }
})
</script>

<style scoped>
.user-dropdown {
  position: absolute;
  top: 50px;
  right: 15px;
}
</style>
